export * from './BaseTab';
export * from './StaffTab';
export * from './SettingsTab';
export * from './ShippingTab';
export * from './PaymentsTab';
export * from './PlatoonsTab';
export * from './ContactsTab';


// WEBPACK FOOTER //
// ./src/pages/base-managment/base/includes/tabs/index.js